import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { PermissionCheckerService, PershingTranslationService } from '@pershing/pershing-core';
import { ModernNavigationService } from '../../services/modern-navigation.service';

@Component({
    selector: 'advisor-info',
    templateUrl: './advisor-info.component.html'
})
export class AdvisorInfoComponent implements OnInit {

    hasEntitled: any;
    serviceError: any;
    ipInfoData: any;
    hasData: any;
    entitledForShowingProfilePic: boolean = false;
    isLoading: boolean;
    constructor(private translationService: PershingTranslationService,
        private modernNavigationService: ModernNavigationService,
        @Optional() @Inject('AppSettings') appSettings: any,
        private authorizationService: PermissionCheckerService) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-modern-navigation', 'node_modules/@pershing/nxi-ng-modern-navigation/lib');
    }
    ngOnInit() {
        this.getAdvisorData();
    }
    getAdvisorData() {
        this.isLoading = true;
        let isEntitledForShowingProfilePic = this.authorizationService.isEntitled('VIEW_ADVISOR_PHOTO_BIO_LINK');
        let hasEntitled = this.authorizationService.isEntitled('FINANCIAL_ADVISOR');
        let reqBody = {
            hasEntitled: hasEntitled,
            isEntitledForShowingProfilePic: isEntitledForShowingProfilePic
        }
        this.modernNavigationService.getFinancialAdvisorData(reqBody).subscribe(
            success => {
                this.entitledForShowingProfilePic = success.response.isEntitledForShowingProfilePic;
                this.hasEntitled = success.response.hasEntitled;
                this.ipInfoData = success.response.ipInfoData;
                this.hasData = success.response.hasData;
                this.isLoading = false;
            },
            (err: HttpErrorResponse) => {
                this.serviceError = true;
                this.isLoading = false;
            }
        );
    }
}
